import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';

function dm_single_person(){
    document.querySelectorAll('.single-person').forEach((section) => {
        const container = section.querySelector('.posts .swiper') || section.querySelector('.swiper');
        if (!container) return;

        // Avoid double init if modal re-renders
        if (container._dm_inited) return;
        container._dm_inited = true;

        // Ensure Swiper structure: wrapper + slides
        let wrapper = container.querySelector(':scope > .swiper-wrapper');
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.className = 'swiper-wrapper';
            const children = Array.from(container.children);
            container.textContent = '';
            container.appendChild(wrapper);
            children.forEach((el) => {
                el.classList.add('swiper-slide');
                wrapper.appendChild(el);
            });
        } else {
            Array.from(wrapper.children).forEach((el) => el.classList.add('swiper-slide'));
        }

        const slideCount = wrapper.children.length;

        // Instantiate against the element (not a selector string)
        new Swiper(container, {
            modules: [Autoplay, EffectFade, Pagination],
            effect: 'fade',
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            loop: slideCount > 1,
            autoHeight: false,
            speed: 600,
            autoplay: slideCount > 1 ? {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            } : false,
            pagination: {
                el: section.querySelector('.swiper-pagination') || null,
                clickable: true,
            },
            observer: true,
            observeParents: true
        });
    });
}

export { dm_single_person };